import { render, staticRenderFns } from "./ActioncamCropRectConfiguration.vue?vue&type=template&id=4987f8ae&"
import script from "./ActioncamCropRectConfiguration.vue?vue&type=script&lang=js&"
export * from "./ActioncamCropRectConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ActioncamCropRectConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports